import { z } from "zod"
import { ServiceAction } from "../service-part-action"

export const PartStoreSettingUpdateSchema = z.object({
  partId: z.guid(),
  action: z.nativeEnum(ServiceAction),
  price: z.number().int().min(0).optional(),
  durationMinutes: z.number().int().min(0).optional(),
  isLocked: z.boolean().optional(),
})

export const BulkUpdatePartStoreSettingsSchema = z.object({
  priceListId: z.guid(),
  updates: z.array(PartStoreSettingUpdateSchema),
})

export type PartStoreSettingUpdate = z.infer<
  typeof PartStoreSettingUpdateSchema
>
export type BulkUpdatePartStoreSettings = z.infer<
  typeof BulkUpdatePartStoreSettingsSchema
>
